export default __webpack_public_path__ + "static/media/url-page-icon.5a10ba30.svg";